import type {UserPropertyADto} from '@cohort/admin-schemas/userProperty';
import DeletionModal from '@cohort/merchants/components/modals/DeletetionModal';
import {useCohortMutation} from '@cohort/merchants/hooks/api/Query';
import {userPropertiesKeys} from '@cohort/merchants/hooks/api/UserProperties';
import {useCurrentMerchant} from '@cohort/merchants/hooks/contexts/currentMerchant';
import {deleteUserProperty} from '@cohort/merchants/lib/api/UserProperties';
import {notifyError} from '@cohort/merchants/stores/ErrorModalStore';
import {useQueryClient} from '@tanstack/react-query';
import React from 'react';
import {useTranslation} from 'react-i18next';

type DeleteUserPropertyModalProps = {
  onClose: () => void;
  userProperty: UserPropertyADto;
};

const DeleteUserPropertyModal: React.FC<DeleteUserPropertyModalProps> = ({
  onClose,
  userProperty,
}) => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'settings.userProperties.removeUserPropertyModal',
  });
  const merchant = useCurrentMerchant();
  const queryClient = useQueryClient();

  const {mutate: deleteUserPropertyMutation} = useCohortMutation({
    mutationFn: async () => deleteUserProperty(merchant.id, userProperty.id),
    onSuccess: async () => {
      await queryClient.invalidateQueries(userPropertiesKeys.userProperties);
      onClose();
    },
    notifySuccessMessage: t('notificationSuccess'),
    onError: err => {
      notifyError(err, t('notificationError'));
      onClose();
    },
  });

  return (
    <DeletionModal
      title={t('title')}
      subtitle={t('subtitle')}
      onClose={onClose}
      onDelete={deleteUserPropertyMutation}
      show
    />
  );
};

export default DeleteUserPropertyModal;
